import {onLoop} from "../utilities/Helper";

class Billboard {
    billboardElement = null;
    currentLeft = 0;
    animationFrameId;
    pause = false;
    fps = 60;
    then = Date.now();
    now;
    rate = 1;
    hover = false;
    cloneOutput = 10;

    constructor(args) {
        if (args !== null) {
            this.billboardElement = args.element;
            this.rate = args.rate !== undefined ? args.rate : 1;
            this.hover = args.hover !== undefined ? args.hover : false;
            this.listElem = this.billboardElement.firstElementChild;
            this.leftSideOfContainer = this.billboardElement.getBoundingClientRect().left;
            this.cancelAnimationFrame = window.cancelAnimationFrame;
            this.cloneListItems();
            this.main();
        }
    }

    cloneListItems() {
        onLoop(this.cloneOutput, () => {
            this.listElem.appendChild(this.listElem.firstElementChild.cloneNode(true))
        });
    }

    main() {
        if (this.hover) {
            this.billboardElement.addEventListener('mouseover', () => {
                this.stop();
            });
            this.billboardElement.addEventListener('mouseleave', () => {
                this.play();
            });
        }
        this.play();
    }

    stop() {
        this.pause = true;
    }

    play() {
        this.pause = false;
        this.animate();
    }

    get interval() {
        return 1000 / this.fps;
    }

    animate() {
        if (this.pause === false) {
            this.animationFrameId = requestAnimationFrame(() => this.animate());
            this.now = Date.now();
            this.delta = this.now - this.then;
            if (this.delta > this.interval) {

                const firstListItem = this.listElem.firstElementChild;

                let rightSideOfFirstItem = Math.floor(firstListItem.getBoundingClientRect().right);

                if (rightSideOfFirstItem <= this.leftSideOfContainer) {// APPEND FIRST ITEM TO END
                    this.currentLeft = -1;
                    this.listElem.appendChild(firstListItem);
                }

                this.listElem.style.marginLeft = `${this.currentLeft}px`;
                this.currentLeft -= this.rate;

                this.then = this.now - (this.delta % this.interval);
            }

        }
    }
}

export default function useBillboard() {
    const billboardInstanceList = [];
    for (const billboardElement of document.querySelectorAll('.billboard')) {
        const billboardInstance = new Billboard({
            element: billboardElement,
            rate: 2
        });
        billboardInstanceList.push(billboardInstance);
    }
    return billboardInstanceList;
}
